import { useState, useEffect } from 'react';

interface FeedbackUrlParams {
  lang: string | null;
  theme: string | null;
  appId: string | null;
  prefill: string | null;
}

function parseFeedbackUrlParams(): FeedbackUrlParams {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    lang: urlParams.get('lang'),
    theme: urlParams.get('theme'),
    appId: urlParams.get('appId'),
    prefill: urlParams.get('prefill'),
  };
}

export function useFeedbackUrlParams(): FeedbackUrlParams {
  const [params, setParams] = useState<FeedbackUrlParams>(() => parseFeedbackUrlParams());

  useEffect(() => {
    const handlePopState = () => {
      setParams(parseFeedbackUrlParams());
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  return params;
}
